<template>
  <modal-notify :isFixed="true" @close="$emit('close')">
    <div slot="header">
      <v-layout>
        <v-flex style="position: absolute; right: 10px; top: 10px">
          <div @click="$emit('close')">
            <img src="/static/img/X.png" alt class="responsive-img pointer" style="height: 20px" />
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs10 sm10 md10>
          <Typography h2 bold label="เพิ่มบรอดแคสต์" />
        </v-flex>
      </v-layout>
    </div>

    <div slot="body">
      <div class="py-3">
        <Typography h5 semiBold color="color-darkGrey" :label="$t('Broadcast Name')" />
        <div class="form-broadcast" :class="{ 'has-error': errors.has('broadcastName') }">
          <input
            type="text"
            class="form-broadcast"
            name="broadcastName"
            placeholder="Broadcast_YYYY_MM_DD_HH_mm"
            data-vv-name="broadcastName"
            :data-vv-as="$t('Broadcast Name')"
            v-validate="'required'"
            v-model="name"
          />
          <span class="text-error" v-show="errors.has('broadcastName')">{{
            errors.first('broadcastName')
          }}</span>
        </div>
      </div>
    </div>

    <div slot="footer" class="text-xs-center">
      <div class="pt-3" style="display: flex; justify-content: center">
        <Button outline :label="$t('cancel')" @click="$emit('close')" />
        <Button depressed :label="$t('Save')" @click="onSave" />
      </div>
    </div>
  </modal-notify>
</template>
  
  <script>
import { mapGetters } from 'vuex'
import ModalNotify from '@/components/elements/ModalNotify'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
import moment from 'moment'
export default {
  //   props: {
  //     type: {
  //       default: 'conversation',
  //     },
  //   },
  data: function () {
    return {
      name: '',
      broadcast: undefined,
      sendtype: 'promotion',
      pushtype: 'SILENT_PUSH', // REGULAR/SILENT_PUSH/NO_PUSH
      message: '',
      quick_reply: '',
      messages: [[]],
      update_status: '',
      update_tags: [],
    }
  },
  components: {
    ModalNotify,
    ScaleLoader,
    InputSearch,
    ToggleButton,
    Typography,
    Button,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
    }),
  },
  methods: {
    onSave: function () {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        vm.$store.dispatch('loading')
        vm.updateBroadcast(false, function (status) {
        })
        $('html, body').animate({ scrollTop: 0 })
      })
    },

    updateBroadcast: function (isSend, callback) {
      var vm = this
      var vm = this
      var scheduletime = moment(vm.scheduleDate + ' ' + vm.scheduleTime)
      var scheduletimeUTC = moment.utc(scheduletime)
      var data = {
        pageid: vm.selectedBot.pageid,
        name: vm.name,
        m_val: vm.message,
        m_type: 'json',
        m_quick_reply: vm.quick_reply,
        m_condition: '',
        sendflag: isSend,
        page_access_token: vm.selectedBot.page_access_token,
        pushtype: vm.pushtype,
        sendtype: vm.sendtype,
        update_status: vm.update_status,
        update_tags: vm.update_tags,
      }
      data.isschedule = false
      data.scheduletime = null

      if (vm.broadcast && vm.broadcast.id) {
        data.broadcastid = vm.broadcast.id
      }
      var messages = [[]]
      if (isSend == true && (messages.length == 0 || messages[0].length == 0)) {
        callback(false)
        return false
      }

      data.m_val = JSON.stringify(messages)

      vm.$emit('onSave', {
        data: data,
        onSave: function (status, broadcastid) {
          if (status) {
            if (broadcastid) {
              data.id = broadcastid
            }
            vm.broadcast = data
            vm.cached_broadcast = Object.assign({}, vm.broadcast)
          }
          callback(status)
        },
      })
    },
  },
}
</script>
  
  <style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/broadcast/AddBroadcast.vue